<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
            <el-tab-pane label="协作办公工作台" name="0">
                <confirmRemind :sectionClassId="3"></confirmRemind>


            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import confirmRemind from '@/components/cooperative/confirmremind'

    //定义组件
    export default {
        data() {
            return {
                activeName:'0',
                activeName1:'0'
            }
        },
        components:{
            confirmRemind,

        }
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative/confirmremind.vue